import * as React from 'react';
import * as mapActions from '../actions/map';
import * as appActions from '../actions/app';
import { connect } from 'react-redux';

import Map from '../components/Map';

class MapContainer extends React.Component {  
    render () {
        return (
            <Map 
                {...this.props} />
        )
    };
}


function mapStateToProps(state) {
    return {
        selectedMap: state.map.selectedMap,
        renderer: state.map.renderer,
        origin: state.map.origin,
        destination: state.map.destination,
        selectedPOI: state.map.selectedPOI,
        locatables: state.location.locatables,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setRenderer: (renderer) => dispatch(mapActions.setRenderer(renderer)),
        setDestination: (destination) => dispatch(mapActions.setDestination(destination)),
        setOrigin: (origin) => dispatch(mapActions.setOrigin(origin)),
        setSelectedPOI: (POI) => dispatch(mapActions.setSelectedPOI(POI)),
        setError: (error) => dispatch(appActions.setError(error)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);


// WEBPACK FOOTER //
// ./src/containers/Map.js